module.exports = __webpack_public_path__ + "static/ring_of_shooting_stars-56259e94a39e51925846cdabd7410088.jpeg";